module.exports = __webpack_public_path__ + "static/media/CP03.068c7022.png";